import {Inject, Injectable} from '@angular/core';
import {TelegramService} from '../page-telegram/telegram.service';
import {WhatsappService} from '../page-whatsapp/whatsapp.service';
import {VkService} from '../page-vk/vk.service';
import {
  Chat,
  Contact,
  IMessengerConnector,
  Message,
  Profile,
  ResultHistory,
  SendMessage
} from '../../types/all.type';
import {from, Observable, ReplaySubject, Subscription, timeout} from 'rxjs';
import {filter, first, take} from 'rxjs/operators';
import {NotifierWrapService} from '../../services/notifier-wrap.service';
import {AllService} from '../../services/all.service';
import {log} from '../../functions';
import {ModalService} from '../../services/modal.service';
import {SnotifyPosition, SnotifyService} from 'ng-snotify';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import Bugsnag from '@bugsnag/js';
import {FellowdeskService} from '../page-fellowdesk/fellowdesk.service';
import {InterfaceService} from '../../services/interface.service';
import {FixTypePipe} from '../../pipes/fixtype.pipe';
import {DcService} from '../../services/dc.service';


@Injectable({
  providedIn: 'root'
})
export class AllMessengersService implements IMessengerConnector {
  public nemuAccounts: IMessengerConnector[] = [];
  public disabledMessageTextarea = false;
  public excludeDomains = [];
  public status = true;
  public loadHistoryError: boolean | any = false;
  public unreadCount = 0;
  public type = 'all';
  public name = 'All';
  public token: string;
  public _openChat: Chat;
  public openChat: Chat;
  public openChatId: number | string;
  public arTyping: any = [];
  public arLocalHistory: any = {};
  public lastNotify: string;
  public environment = environment;
  public urlApi: any = environment.tg;
  public _openChatId: any;
  public arProfile: Profile = {} as Profile;
  public active = 'fellowdesk';
  public setService$: ReplaySubject<void> = new ReplaySubject();
  public Service: IMessengerConnector;
  public arServices: IMessengerConnector[] = [];
  public setLocalHistory$: ReplaySubject<{
    id: string | number, arHistory: Message[]
  }> = new ReplaySubject();
  arHistory: Message[];
  public replyMessage: false | Message;
  public forwardMessage: Message | false = false;
  public editMessage: false | Message;
  messageLastDate: number;
  bufferMessage: string;
  message: string;
  isLoadedProfile = true;
  isLoadedProfileError: boolean;
  reloadRequestsSubscription: Subscription;
  arVisibleStickers: any;
  isDeleteAllMessage: boolean;

  public resetTextVariations$: ReplaySubject<void> = new ReplaySubject();
  public getProfile$: ReplaySubject<Profile> = new ReplaySubject();
  public arTextVariations: {text: string}[];

  constructor(
    private dcService: DcService,
    public interfaceService: InterfaceService,
    private snotifyService: SnotifyService,
    public modalService: ModalService,
    public allService: AllService,
    public vkService: VkService,
    public telegramService: TelegramService,
    @Inject('TelegramService2') public telegramService2: TelegramService,
    @Inject('TelegramService3') public telegramService3: TelegramService,
    @Inject('TelegramService4') public telegramService4: TelegramService,
    @Inject('TelegramService5') public telegramService5: TelegramService,
    @Inject('TelegramService6') public telegramService6: TelegramService,
    @Inject('TelegramService7') public telegramService7: TelegramService,
    @Inject('TelegramService8') public telegramService8: TelegramService,
    @Inject('TelegramService9') public telegramService9: TelegramService,
    @Inject('TelegramService10') public telegramService10: TelegramService,
    @Inject('TelegramService11') public telegramService11: TelegramService,
    @Inject('TelegramService12') public telegramService12: TelegramService,
    @Inject('TelegramService13') public telegramService13: TelegramService,
    @Inject('TelegramService14') public telegramService14: TelegramService,
    @Inject('TelegramService15') public telegramService15: TelegramService,
    @Inject('TelegramService16') public telegramService16: TelegramService,
    @Inject('TelegramService17') public telegramService17: TelegramService,
    @Inject('TelegramService18') public telegramService18: TelegramService,
    @Inject('TelegramService19') public telegramService19: TelegramService,
    @Inject('TelegramService20') public telegramService20: TelegramService,
    @Inject('TelegramService21') public telegramService21: TelegramService,
    @Inject('TelegramService22') public telegramService22: TelegramService,
    @Inject('TelegramService23') public telegramService23: TelegramService,
    @Inject('TelegramService24') public telegramService24: TelegramService,
    @Inject('TelegramService25') public telegramService25: TelegramService,
    @Inject('TelegramService26') public telegramService26: TelegramService,
    @Inject('TelegramService27') public telegramService27: TelegramService,
    @Inject('TelegramService28') public telegramService28: TelegramService,
    @Inject('TelegramService29') public telegramService29: TelegramService,
    @Inject('TelegramService30') public telegramService30: TelegramService,
    @Inject('TelegramService31') public telegramService31: TelegramService,
    @Inject('TelegramService32') public telegramService32: TelegramService,
    @Inject('TelegramService33') public telegramService33: TelegramService,
    @Inject('TelegramService34') public telegramService34: TelegramService,
    @Inject('TelegramService35') public telegramService35: TelegramService,
    @Inject('TelegramService36') public telegramService36: TelegramService,
    @Inject('TelegramService37') public telegramService37: TelegramService,
    @Inject('TelegramService38') public telegramService38: TelegramService,
    @Inject('TelegramService39') public telegramService39: TelegramService,
    @Inject('TelegramService40') public telegramService40: TelegramService,
    @Inject('TelegramService41') public telegramService41: TelegramService,
    @Inject('TelegramService42') public telegramService42: TelegramService,
    @Inject('TelegramService43') public telegramService43: TelegramService,
    @Inject('TelegramService44') public telegramService44: TelegramService,
    @Inject('TelegramService45') public telegramService45: TelegramService,
    @Inject('TelegramService46') public telegramService46: TelegramService,
    @Inject('TelegramService47') public telegramService47: TelegramService,
    @Inject('TelegramService48') public telegramService48: TelegramService,
    @Inject('TelegramService49') public telegramService49: TelegramService,
    @Inject('TelegramService50') public telegramService50: TelegramService,
    @Inject('TelegramService51') public telegramService51: TelegramService,
    @Inject('TelegramService52') public telegramService52: TelegramService,
    @Inject('TelegramService53') public telegramService53: TelegramService,
    @Inject('TelegramService54') public telegramService54: TelegramService,
    @Inject('TelegramService55') public telegramService55: TelegramService,
    @Inject('TelegramService56') public telegramService56: TelegramService,
    @Inject('TelegramService57') public telegramService57: TelegramService,
    @Inject('TelegramService58') public telegramService58: TelegramService,
    @Inject('TelegramService59') public telegramService59: TelegramService,
    @Inject('TelegramService60') public telegramService60: TelegramService,
    public whatsappService: WhatsappService,
    public fellowdeskService: FellowdeskService,
    public notifierWrapService: NotifierWrapService,
    public router: Router,
    public fixTypePipe: FixTypePipe
  ) {
    this.telegramService2.type = 'telegram|2';
    this.telegramService3.type = 'telegram|3';
    this.telegramService4.type = 'telegram|4';
    this.telegramService5.type = 'telegram|5';
    this.telegramService6.type = 'telegram|6';
    this.telegramService7.type = 'telegram|7';
    this.telegramService8.type = 'telegram|8';
    this.telegramService9.type = 'telegram|9';
    this.telegramService10.type = 'telegram|10';
    this.telegramService11.type = 'telegram|11';
    this.telegramService12.type = 'telegram|12';
    this.telegramService13.type = 'telegram|13';
    this.telegramService14.type = 'telegram|14';
    this.telegramService15.type = 'telegram|15';
    this.telegramService16.type = 'telegram|16';
    this.telegramService17.type = 'telegram|17';
    this.telegramService18.type = 'telegram|18';
    this.telegramService19.type = 'telegram|19';
    this.telegramService20.type = 'telegram|20';
    this.telegramService21.type = 'telegram|21';
    this.telegramService22.type = 'telegram|22';
    this.telegramService23.type = 'telegram|23';
    this.telegramService24.type = 'telegram|24';
    this.telegramService25.type = 'telegram|25';
    this.telegramService26.type = 'telegram|26';
    this.telegramService27.type = 'telegram|27';
    this.telegramService28.type = 'telegram|28';
    this.telegramService29.type = 'telegram|29';
    this.telegramService30.type = 'telegram|30';
    this.telegramService31.type = 'telegram|31';
    this.telegramService32.type = 'telegram|32';
    this.telegramService33.type = 'telegram|33';
    this.telegramService34.type = 'telegram|34';
    this.telegramService35.type = 'telegram|35';
    this.telegramService36.type = 'telegram|36';
    this.telegramService37.type = 'telegram|37';
    this.telegramService38.type = 'telegram|38';
    this.telegramService39.type = 'telegram|39';
    this.telegramService40.type = 'telegram|40';
    this.telegramService41.type = 'telegram|41';
    this.telegramService42.type = 'telegram|42';
    this.telegramService43.type = 'telegram|43';
    this.telegramService44.type = 'telegram|44';
    this.telegramService45.type = 'telegram|45';
    this.telegramService46.type = 'telegram|46';
    this.telegramService47.type = 'telegram|47';
    this.telegramService48.type = 'telegram|48';
    this.telegramService49.type = 'telegram|49';
    this.telegramService50.type = 'telegram|50';
    this.telegramService51.type = 'telegram|51';
    this.telegramService52.type = 'telegram|52';
    this.telegramService53.type = 'telegram|53';
    this.telegramService54.type = 'telegram|54';
    this.telegramService55.type = 'telegram|55';
    this.telegramService56.type = 'telegram|56';
    this.telegramService57.type = 'telegram|57';
    this.telegramService58.type = 'telegram|58';
    this.telegramService59.type = 'telegram|59';
    this.telegramService60.type = 'telegram|60';
    this.arServices = [
      this.telegramService,
      this.telegramService2,
      this.telegramService3,
      this.telegramService4,
      this.telegramService5,
      this.telegramService6,
      this.telegramService7,
      this.telegramService8,
      this.telegramService9,
      this.telegramService10,
      this.telegramService11,
      this.telegramService12,
      this.telegramService13,
      this.telegramService14,
      this.telegramService15,
      this.telegramService16,
      this.telegramService17,
      this.telegramService18,
      this.telegramService19,
      this.telegramService20,
      this.telegramService21,
      this.telegramService22,
      this.telegramService23,
      this.telegramService24,
      this.telegramService25,
      this.telegramService26,
      this.telegramService27,
      this.telegramService28,
      this.telegramService29,
      this.telegramService30,
      this.telegramService31,
      this.telegramService32,
      this.telegramService33,
      this.telegramService34,
      this.telegramService35,
      this.telegramService36,
      this.telegramService37,
      this.telegramService38,
      this.telegramService39,
      this.telegramService40,
      this.telegramService41,
      this.telegramService42,
      this.telegramService43,
      this.telegramService44,
      this.telegramService45,
      this.telegramService46,
      this.telegramService47,
      this.telegramService48,
      this.telegramService49,
      this.telegramService50,
      this.telegramService51,
      this.telegramService52,
      this.telegramService53,
      this.telegramService54,
      this.telegramService55,
      this.telegramService56,
      this.telegramService57,
      this.telegramService58,
      this.telegramService59,
      this.telegramService60,
      this.vkService,
      // this.whatsappService,
      this.fellowdeskService
      // this.skypeService,
    ].filter((v) => !v.excludeDomains.includes(location.host));

    // WS set active token
    this.wsSetActiveToken();

    this.resetTextVariations$.subscribe(() => {
      this.arTextVariations = [
        {text: this.Service.message}, {text: ''}
      ];
    });

    this.setFirstService();
    this.interfaceService.openChat$.subscribe((data) => {
      if (!data) {
        return;
      }
      if (data?.chat.service_type) {
        if (data?.chat?.id !== 'sender') {
          this.router.navigate(['/ui']);
        }
        if (data.Service) {
          this.Service = data.Service;
          this.setService$.next();
        } else {
          this.setServiceActive(data.chat.service_type);
        }
        log('AllMessengersService set data', this.Service.type);
        // this.Service.openChat = data.chat;
      } else {
        log('AllMessengersService openChat$ SKIP', data);

        Bugsnag.notify(new Error('AllMessengersService service_type not found'));
        // alert('AllMessengersService service_type not found');
      }
    });
    this.allService.login$.subscribe(() => {
      this.interfaceService.goToEvent('AUTH_SERVICE');
      this.allService.serviceType = 'all';
      this.Service = this.fellowdeskService;
      this.active = this.type;
      // this.setService$.next();
      if (this.modalService.bsModalRef) {
        this.modalService.bsModalRef?.hide();
      }
      if (this.arServicesAuthorized?.length === 1) {
        this.interfaceService.goToEvent('REGISTER_SERVICE');
      }
    });
    this.allService.wsService.status.pipe(filter((v) => v)).subscribe((status) => {
      this.getServicesFilter('isAuth', true).filter((v) => v.type.includes('telegram')).map((Servie) => {
        setTimeout(() => {
          const key = `init_app_handle`;
          this.telegramService.sendEvent(key, {
            token: Servie.token,
            type: Servie.type
          });
        }, 5000);
      });
    });
  }
  wsSetActiveToken() {
    /*setTimeout(() => {
      const Service = this.arServices.find((v) => v.isAuth && v instanceof TelegramService);
      if (Service?.token) {
        this.allService.wsService.token = Service.token;
        this.allService.wsService.initConfig();
        this.allService.wsService.connect();

        console.log('wsSetActiveToken', Service.token);
      }
    }, 10);*/
  }

  getUploadUrl(chatId: string | number, type?: string): Observable<{ uploadUrl: string, method: 'post' | 'put' }> {
    throw new Error('Method not implemented.');
  }

  addedFile(file: File): Observable<{ uploadUrl: string }> {
    throw new Error('Method not implemented.');
  }

  saveFile(file: File | Blob, title?: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  logout(onlyToken: boolean): void {
    throw new Error('Method not implemented.');
  }

  setLocalHistory(id: any, arHistory: Message[]): void {
    throw new Error('Method not implemented.');
  }

  loadProfile(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getProfile(initiator = 'all'): Observable<Profile> {
    log('AllMessengersService::getProfile()', initiator);
    const arServices = this.arServicesAuthorized;
    return new Observable((observer) => {
      for (let i = 0; i < arServices.length; i++) {
        const Service = arServices[i];
        Service.getProfile(initiator).subscribe((res) => {
          Service.isLoadedProfile = true;
          // log('AllMessengersService::getProfile()', Service.type, arServices?.length)
          observer.next(res);
        }, error => {
          observer.error(error);
          observer.complete();
        });
      }
    }).pipe(take(arServices?.length)) as any;
  }

  forwardMessages(chatId: any, fromChatId: any, messages: Message[]): Observable<any> {
    throw new Error('Method not implemented.');
  }

  deleteMessages(chatId: any, revoke: boolean, messageIds: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  saveMessage(arData: Message): Observable<any> {
    throw new Error('Method not implemented.');
  }

  sendMessage(arData: SendMessage): Observable<Message[]> {
    throw new Error('Method not implemented.');
  }

  sendKeyBoard(arData: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getDetailInfo(id: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  chatSearch(id: any, filter: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getChatSearch(id: any, filter: string, query: string, offset: number, limit: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getGlobalSearch(query: string, limit: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  sendVoice(file: any, chat_id: string | number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getFile(fileId: string, fileUniqueId: string, ungzip: boolean): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getStickers(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getGifs(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  deleteFile(uri: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  setNotify(arData: any): Observable<any> {
    const Service = this.getService(arData.type);
    if (Service) {
      return Service.setNotify(arData);
    } else {
      throw new Error('Service not found.');
    }
  }

  getNotify(peer: string | number, chat: Chat): Observable<any> {
    const Service = this.getService(chat.service_type);
    if (Service) {
      return Service.getNotify(peer, chat);
    } else {
      throw new Error('Service not found.');
    }
  }

  getFileSrc(attachment: any): string {
    throw new Error('Method not implemented.');
  }

  getFile$(fileId: string, fileUniqueId: string, log = '') {
    throw new Error('Method not implemented.');
  }

  getThumbSrc(attachment: any): void {
    throw new Error('Method not implemented.');
  }

  loadAttachment$(attachment: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  loadAudio$(attachment: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  chatNew(title: string, arUsers: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getHistory(
    chatId: string | number,
    offsetId: string | number,
    currentCount: number,
    limit?: number,
    cursor?: any
  ): Observable<ResultHistory> {
    throw new Error('Method not implemented.');
  }

  addChatUser(chatId: string | number, useId: string | number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  leaveChat(chat: Chat, del = false, envService: IMessengerConnector): Observable<any> {
    return new Observable((observer) => {
      const chatService = this.getService(chat.service_type);
      this.snotifyService.clear();
      this.snotifyService.confirm(
        'Вы точно хотите' + (del ? ' удалить и' : '') + ' покинуть чат?',
        'Покинуть чат' + (del ? ' и удалить' : ''),
        {
          timeout: 30000,
          titleMaxLength: 30,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          position: SnotifyPosition.centerTop,
          buttons: [
            {
              text: 'Да',
              action: () => {
                chatService.leaveChat(chat.id, del).subscribe(
                  (result: any) => {
                    this.allService.arChat = this.allService.arChat.filter((v) => v.id !== chat.id);
                    if (chatService.openChatId === chat.id) {
                      log('leaveChat');
                      delete chatService._openChatId;
                    }
                    this.dcService.detectChanges$.next('chat-list');
                    this.dcService.detectChanges$.next('chat-show');
                    this.allService.saveLocalChats$.next();
                    observer.next(result);
                    observer.complete();
                  },
                  (error) => {
                    observer.next(error);
                    observer.complete();
                    this.interfaceService.errorHandling(error, true, chatService);
                  }
                );
              },
              bold: false
            },
            {
              text: 'Отменить', action: () => {
                log('Clicked: No');
                observer.next('Clicked: No');
                observer.complete();
              }
            }
          ]
        }
      );
    }).pipe(first());
  }

  public getServicesFilter(field: string, value: any): IMessengerConnector[] {
    const arServices: IMessengerConnector[] = [];
    this.arServices.forEach((Service) => {
      if (Service[field] === value) {
        arServices.push(Service);
      }
    });
    return arServices;
  }

  public arServicesNeedAuthorized(): IMessengerConnector[] {
    const arServices: IMessengerConnector[] = [];
    for (const Service of this.getServicesFilter('isAuth', false)) {
      if (Service.type.indexOf('|') > -1) {
        const fixType = this.fixTypePipe.transform(Service.type);
        console.log(fixType, 'fixType', arServices.findIndex((v) => v.type.indexOf(fixType) === -1));
        if (arServices.findIndex((v) => v.type.indexOf(fixType) > -1) === -1) {
          arServices.push(Service);
        }
      } else {
        arServices.push(Service);
      }
    }
    return arServices;
  }

  get arServicesAuthorized(): IMessengerConnector[] {
    return this.getServicesFilter('isAuth', true);
  }
  get isAuth(): boolean {
    return this.arServicesAuthorized.length > 0;
  }
  getConnectList(status = false): string[] {
    const arList = [];
    from(this.arServicesAuthorized)
      .pipe(filter((Service: IMessengerConnector) => Service.status === status))
      .subscribe((Service: IMessengerConnector) => {
        if (!arList.includes(Service.name)) {
          arList.push(Service.name);
        }
      });
    return arList;
  }

  public getService(type: string): IMessengerConnector {
    if (type === 'all') {
      return this;
    } else {
      return this.arServices.find((v) => v.type === type);
    }
  }

  setServiceActive(serviceType: string, allServiceEvent = true): void {
    const findService = this.getService(serviceType);
    if (findService) {
      // TODO надо не удалять для оптимизации переклчения массенджера
      delete findService._openChatId;
      delete this.allService._openChatId;
      this.Service = findService;
      this.active = this.Service.type;
      this.setService$.next();
      if (allServiceEvent) {
        this.allService.setService$.next(this.Service.type);
      }
    } else {
      console.error('AllMessengersService: findService', serviceType);
    }
  }

  mergeChats(results: Chat[]): void {
    results.forEach((v) => {
      const findMessageIndex = this.allService.arChat.findIndex((val) => val.id === v.id && val.service_type === v.service_type);
      if (findMessageIndex === -1) {
        this.allService.arChat.push(v);
      } else {
        this.allService.arChat[findMessageIndex] = v;
      }
    });
  }

  mergeContacts(results: Contact[]): void {
    results.forEach((v) => {
      const findMessageIndex = this.allService.arContacts.findIndex((val) => val.id === v.id);
      if (findMessageIndex === -1) {
        this.allService.arContacts.push(v);
      } else {
        this.allService.arContacts[findMessageIndex] = v;
      }
    });
  }

  chatList(filterType = '', offsetDate = 0): Observable<{ results: Chat[] }> {
    const arServices = this.arServicesAuthorized;
    console.log(arServices);
    return new Observable((observer) => {
      for (let i = 0; i < arServices?.length; i++) {
        const Service = arServices[i];
        console.log('!!!!!', Service)
        Service.chatList(filterType, offsetDate).pipe(timeout(15000)).subscribe((res: any) => {
          res.results.map((v) => {
            v.service_type = Service.type;
          });
              observer.next(res);
              observer.complete();
        },
        (error: any) => {
          // Обработка ошибки таймаута
          observer.error(error);
          observer.complete();
        });
      }
    }).pipe(take(arServices?.length)) as any;
  }

  readHistory(chatId, maxId: string | number) {
    return new Observable((observer) => {
      observer.next({});
      observer.complete();
    }).pipe(first());
  }

  toggleChatPine(id, pinned: boolean) {
    return new Observable((observer) => {
      observer.next();
      observer.complete();
    }).pipe(first());
  }

  contactsList(q = '', online: any = '', count = 200): Observable<{ results: Chat[] | Contact[] }> {
    const cutList = (res) => {
      res.results = res.results.slice(-count);
    };
    const arServices = this.getServicesFilter('isAuth', true);
    return new Observable((observer) => {
      for (let i = 0; i < arServices.length; i++) {
        const Service = arServices[i];
        Service.contactsList(q, online, count, 50).subscribe((res) => {
          res.results.map((v) => (v.service_type = Service.type));
          cutList(res);
          observer.next(res);
        }, error => {
          this.interfaceService.errorHandling(error, true, Service);
        });
      }
    }).pipe(take(arServices?.length)) as any;
  }

  setVarLocal(name: string, val: any): void {
    try {
      localStorage.setItem('all_' + name + '_' + this.token, JSON.stringify(val));
    } catch (e) {
      console.error('setVarLocal error', e, val);
    }
  }

  getVarLocal(name: string, defaultValue: any = {}) {
    try {
      return JSON.parse(localStorage.getItem('all_' + name + '_' + this.token)) || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }

  // Отработка ошибок, для вызовов запросов без подписки
  errorHandling(error: any, isNotify = true): string | void {
    log('error');
    let errorText = '';
    switch (error.status) {
      case 401:
        errorText = 'Один из аккаунтов был разлогинен, напишите нам, если считаете это ошибкой.';
        break;
      case 408:
        errorText = 'Слишком много похожих запросов. Подождите...';
        break;
      case 304:
        errorText = 'Не изменилось.';
        break;
      case 404:
        errorText = 'Элемент не найден.';
        break;
      case 400:
        errorText = 'Ошибка запроса, обратитесь в техподдержку.';
        break;
      case 403:
        errorText = 'Доступ запрещен.';
        break;
      case 500:
        errorText = 'Произошла ошибка, попробуйте позже или обратитесь в техподдержку.';
        break;
      case 0:
        errorText = 'Сервис временно недоступен, попробуйте позже или обратитесь в техподдержку.';
        break;
      default:
        log('default', error);
        errorText = 'Сервер временно не доступен, попробуйте позже.';
    }
    const notify = error?.error?.error_msg || errorText;
    if (isNotify && this.lastNotify !== notify) {
      this.notifierWrapService.notify('error', error?.error?.error_msg || errorText);
      this.lastNotify = notify;
    } else {
      return errorText;
    }
  }

  // Set first active service
  private setFirstService(): void {
    const Service = this.arServicesAuthorized[0];
    if (Service?.type) {
      this.Service = Service;
      this.active = Service.type;
      this.setService$.next();
    }
  }
}
